import { render } from "./MenuSetting.vue?vue&type=template&id=7256f20c&scoped=true"
import script from "./MenuSetting.vue?vue&type=script&lang=js"
export * from "./MenuSetting.vue?vue&type=script&lang=js"

import "./MenuSetting.vue?vue&type=style&index=0&id=7256f20c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7256f20c"]])

export default __exports__